import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { models } from 'powerbi-client';

export type PowerBIEventHandler = (event?: { detail?: unknown }, embeddedEntity?: unknown) => void | null;

@Component({
  selector: 'app-powerbi-report',

  templateUrl: './powerbi-report.component.html',
  styleUrl: './powerbi-report.component.scss'
})
export class PowerbiReportComponent implements OnChanges {

  @Input() reportConfig: {
    type: 'report',
    id: '',
    embedUrl: '',
    accessToken: '', tokenType: models.TokenType.Embed,
    hostname: "https://app.powerbi.com",
    settings: {
      panes: {
        filters: { visible: false },
        pageNavigation: { visible: false }
      }
    }
  };

  /** Optional: event handlers for the embed (e.g. dataHyperlinkClicked, tileClicked) to intercept navigation. */
  @Input() eventHandlers?: Map<string, PowerBIEventHandler> | null;

  /** Toggled false→true on config changes to force Power BI to destroy and recreate the iframe
   * so both the paginated-reports wrapper and the rdlEmbed doc requests fire on every (re-)click. */
  show = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['reportConfig'] && !changes['reportConfig'].isFirstChange()) {
      this.show = false;
      setTimeout(() => { this.show = true; }, 0);
    }
  }

}